import React from 'react';

import { faPlus } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { useGoogleAuth } from '../../../hooks';

const CONNECT_GOOGLE_URL = '/google-calendar/connect';

const ConnectGoogleButton = () => {
  useGoogleAuth();

  const handleClick = () => {
    window.location.href = CONNECT_GOOGLE_URL;
  };

  return (
    <Button onClick={handleClick} variant="outline">
      <FontAwesomeIcon icon={faPlus} />
      Connect Google
    </Button>
  );
};

export default ConnectGoogleButton;
